import axios from 'axios';
import Vue from 'vue';
import store from '../store';

const baseURL = process.env.VUE_APP_API_URL;

const service = axios.create({
  baseURL,
  timeout: 30000
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    const token = localStorage.getItem('at');
    config.headers['Access-Control-Allow-Origin'] = '*';
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Do something with request error
    console.error('error:', error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const at = localStorage.getItem('at');
    const rt = localStorage.getItem('rt');
    if (error.response && error.response.status === 401 && at && rt) {
      try {
        const res = await fetch(`${baseURL}/auth/refresh-token`, {
          method: 'post',
          body: JSON.stringify({
            access_token: at,
            refresh_token: rt
          }),
          headers: new Headers({ authorization: `Bearer ${rt}` })
        });

        const { access_token } = await res.json();
        // refresh token error 刪除 localStorage & 登出
        if (!access_token) {
          localStorage.removeItem('at');
          localStorage.removeItem('rt');
          store.dispatch('auth/DO_LOGOUT');
        } else {
          localStorage.setItem('at', access_token);
        }
      } catch (err) {
        store.dispatch('auth/DO_LOGOUT');
        console.error('refresh token error');
        console.error(err);

        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const api = async (
  method = 'get',
  url,
  data = {},
  params = {},
  retry = true,
  silence = false
) => {
  method = method.toLowerCase();
  if (data === 'no-data') {
    data = {};
    params = {};
  }

  let config = {};

  if (method === 'upload') {
    config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
  }

  method = method === 'upload' ? 'post' : method;

  try {
    const result = await service.request({
      method,
      url,
      data,
      params: method.toLowerCase() === 'get' ? data : params,
      config
    });
    return result;
  } catch (error) {
    const detail = error.response
      ? error.response.data || error.response
      : error;

    if (error.response && error.response.status === 401 && retry) {
      const result = await api(method, url, data, params, false);
      let detail = {};
      const at = localStorage.getItem('at');
      const rt = localStorage.getItem('rt');

      if (result.error) {
        detail = result.error.response
          ? result.error.response.data || result.error.response
          : result.error;
      }

      return !result.error ? result : { error: detail };
    }

    return { error: detail };
  }
};

api.get = (url, data, params = {}) => api('get', url, data, params);
api.post = (url, data, params = {}) => api('post', url, data, params);
api.put = (url, data, params = {}) => api('put', url, data, params);
api.patch = (url, data, params = {}) => api('patch', url, data, params);
api.delete = (url, data, params = {}) => api('delete', url, data, params);
